import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { PopupDomainFavoriteComponent } from './popup-domain-favorite';
import { OnInit } from '@opten/compiler/metadata/lifecycle';


@Component({ className: 'js-popup-domain-favorite-link', observe: true})
export class PopupDomainFavoriteLinkComponent implements OnInit {
	@ComponentRef(PopupDomainFavoriteComponent) popupDomainFavoritesComponent: PopupDomainFavoriteComponent;
	constructor(private element: HTMLElement) {	}
	onInit(): void {
		if (this.popupDomainFavoritesComponent && this.popupDomainFavoritesComponent != null) {

			this.element.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.stopPropagation();
				const link = this.element.getAttribute('href');
				const title = this.element.getAttribute('title');
				const target = this.element.hasAttribute('target') ? this.element.getAttribute('target') : '';
				this.popupDomainFavoritesComponent.togglePopup(link, title, target);
			});
		}
	}
}